import { Time } from 'interfaces/time';

export function parseTimeFormat(time: string): Time {
  const split = time.split(':');
  const [minutes, seconds] = split;

  return {
    minutes: Number(minutes),
    seconds: Number(seconds),
  };
}

export default function formatTime(minutes: number, seconds: number): string {
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
